export enum DisputeReason {
  PRODUCT_NOT_RECEIVED = 'PRODUCT_NOT_RECEIVED',
  PRODUCT_NOT_AS_DESCRIBED = 'PRODUCT_NOT_AS_DESCRIBED',
  PRODUCT_WAS_FAULTY = 'PRODUCT_WAS_FAULTY',
  OTHER = 'OTHER',
}

export const DISPUTE_REASON_OPTIONS = [
  {
    value: DisputeReason.PRODUCT_NOT_RECEIVED,
    id: 1,
  },
  {
    value: DisputeReason.PRODUCT_NOT_AS_DESCRIBED,
    id: 2,
  },
  {
    value: DisputeReason.PRODUCT_WAS_FAULTY,
    id: 3,
  },
  {
    value: DisputeReason.OTHER,
    id: 4,
  },
] as const
